// Important: this file is generated from the 'build' script and should not be
// edited directly
export const version = '4.1.0';
